'use strict';
module.exports = {
  FormInputRegex: function () {
    $('.form-regex-caractere input[type=text]').bind('input', function () {
      var c = this.selectionStart,
        pattern = /[^a-zA-Z0-9 '-]/gi,
        valInput = $(this).val();
      if (pattern.test(valInput)) {
        $(this).val(valInput.replace(pattern, ''));
        c--;
      }
      this.setSelectionRange(c, c);
    });
  }
};
